import { login } from './index'

// 공통 필터 메서드 적용 
import { checkLimitedUser } from './function/method'

function userLogin(option) {
  return login.post('login.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

export { userLogin }